import { Routes } from '@angular/router';

export enum UserManagementRouteAliases {
  USER = 'userAlias',
}

export enum UserManagementRouteNames {
  USER_REGISTER = 'register',
}

export const USER_MANAGEMENT_ROUTES: Routes = [
  {
    path: '',
    pathMatch: 'full',
    redirectTo: 'listing',
  },
  {
    path: 'listing',
    loadComponent: () => import('@pages/user-management/users-listing/users-listing.page').then((p) => p.UsersListingPage),
    data: {
      breadcrumb: { skip: true },
    },
  },
  {
    path: `:userId/:userEmail`,
    data: {
      breadcrumb: {
        label: 'ROUTES.USER_DATA',
        alias: UserManagementRouteAliases.USER,
      },
    },
    loadComponent: () => import('@pages/user-management/individual-user/individual-user.page').then((p) => p.IndividualUserPage),
    children: [
      {
        path: '',
        pathMatch: 'full',
        redirectTo: 'data',
      },
      {
        path: 'data',
        loadComponent: () =>
          import('@pages/user-management/individual-user/individual-user-data/individual-user-data.page').then(
            (p) => p.IndividualUserDataPage
          ),
        data: {
          breadcrumb: {
            skip: true,
          },
        },
      },
      {
        path: 'edit',
        loadComponent: () =>
          import('@pages/user-management/individual-user/individual-user-edit/individual-user-edit.page').then(
            (p) => p.IndividualUserEditPage
          ),
        data: {
          breadcrumb: {
            skip: true,
          },
        },
      },
    ],
  },
  {
    path: UserManagementRouteNames.USER_REGISTER,
    loadComponent: () => import('@pages/user-management/user-register/user-register.page').then((p) => p.UserRegisterPage),
    data: {
      breadcrumb: {
        label: 'ACTIONS.NEW_USER',
      },
    },
  },
];
